























































import {Component, Vue} from 'vue-property-decorator'
import mock from '../../mock/Result';

@Component
export default class Patent extends Vue {
  contentPlatform = [{}];
  enContentPlatform = [{}];
  private targetNamePlatform: string = 'succ_result';
  private contentPatent: string = '';
  private enContentPatent: string = '';
  private targetNamePatent: string = 'succ_patent';
  private contentCopyright: string = '';
  private enContentCopyright: string = '';
  private targetNameCopyright: string = 'succ_copyright';

  private mounted() {
    this.getContent();
  }

  private getContent() {
    this.contentPlatform = mock.ContentPlatform;
    // this.enContentPlatform = mock.EnContentPlatform;

    // this.contentCopyright = mock.ContentCopyright;
    // this.enContentCopyright = mock.EnContentCopyright;
    // const loadInstance = Loading.service({target: '.ql-editor'});
    // $api.module.findContentByName(this.targetNamePlatform)
    //     .then((res) => {
    //        let contentPlatform = (res as any).content;
    //       this.contentPlatform = contentPlatform.replace(new RegExp('net:9000/assets', 'g'), 'net/assets')
    //       loadInstance.close();
    //     }).catch((error) => {
    //   loadInstance.close();
    //   Notification({
    //     title: '网络异常',
    //     message: error,
    //     type: 'error',
    //   });
    // })
    // $api.module.findContentByName('en_' + this.targetNamePlatform)
    //     .then((res) => {
    //       let enContentPlatform = (res as any).content;
    //       this.enContentPlatform = enContentPlatform.replace(new RegExp('net:9000/assets', 'g'), 'net/assets')
    //     })
    //
    // $api.module.findContentByName(this.targetNamePatent)
    //     .then((res) => {
    //       this.contentPatent = (res as any).content;
    //       loadInstance.close();
    //     }).catch((error) => {
    //   loadInstance.close();
    //   Notification({
    //     title: '网络异常',
    //     message: error,
    //     type: 'error',
    //   });
    // })
    // $api.module.findContentByName('en_' + this.targetNamePatent)
    //     .then((res) => {
    //       this.enContentPatent = (res as any).content;
    //     })
    //
    // $api.module.findContentByName(this.targetNameCopyright)
    //     .then((res) => {
    //       this.contentCopyright = (res as any).content;
    //       loadInstance.close();
    //     }).catch((error) => {
    //   loadInstance.close();
    //   Notification({
    //     title: '网络异常',
    //     message: error,
    //     type: 'error',
    //   });
    // })
    // $api.module.findContentByName('en_' + this.targetNameCopyright)
    //     .then((res) => {
    //       this.enContentCopyright = (res as any).content;
    //     })
  }
}
